// Headless UI closes a Dialog on any pointer press outside its panel — including
// presses on the scroll container's scrollbar, which users hit constantly on tall
// modals (macOS overlay scrollbars only appear once you reach for them). Modals
// here are dismissed with their X / Cancel button, so swallow pointer events that
// land on the dialog chrome (backdrop, scroll container) outside the panel.
// Escape still closes, since that goes through a separate keydown handler.

// True when the event target sits inside an open dialog but outside its panel.
export function isDialogChromeTarget(target) {
    if (!target || typeof target.closest !== 'function') return false
    const dialog = target.closest('[role="dialog"]')
    if (!dialog) return false
    const panel = dialog.querySelector('[id^="headlessui-dialog-panel-"]')
    if (!panel) return false // no panel to compare against: leave behaviour untouched
    return !panel.contains(target)
}

export default function installDialogDismissGuard() {
    const guard = (e) => {
        if (isDialogChromeTarget(e.target)) e.stopImmediatePropagation()
    }
    // Capture phase on document runs before Headless UI's own document listeners
    // and before React's root-container listeners.
    ;['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'click'].forEach((type) =>
        document.addEventListener(type, guard, true)
    )
}
